import {
  LogLevel,
  PublicClientApplication,
  type Configuration,
  type PopupRequest,
  type RedirectRequest,
} from '@azure/msal-browser';

import { env, isAuthConfigured } from '../config/env.js';

const configuration: Configuration = {
  auth: {
    clientId: env.entra.clientId,
    authority: env.entra.authority,
    redirectUri: env.entra.redirectUri,
    postLogoutRedirectUri: env.entra.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
      loggerCallback: () => {
        // Intentionally silent; surface auth failures through the UI instead.
      },
    },
  },
};

/**
 * The singleton MSAL instance, or `null` when Entra is not configured.
 * Consumers must guard on `isAuthConfigured` before using it.
 */
export const msalInstance: PublicClientApplication | null = isAuthConfigured
  ? new PublicClientApplication(configuration)
  : null;

/** Scopes requested during interactive sign-in. */
export const loginRequest: RedirectRequest & PopupRequest = {
  scopes: env.entra.apiScope ? [env.entra.apiScope] : ['User.Read'],
};

/** Scopes requested when acquiring an access token for the PSA API. */
export const apiTokenRequest: { scopes: string[] } = {
  scopes: env.entra.apiScope
    ? [env.entra.apiScope]
    : env.entra.clientId
      ? [`${env.entra.clientId}/.default`]
      : [],
};
